module.exports = __webpack_public_path__ + "static/media/textBox.d82fe94f.png";